import React, { useState, useEffect } from 'react';
import axios from 'axios';
import cors from 'cors';
import './App.css';
import Work from "./Work";

//axios.defaults.baseURL = "https://127.0.0.1:5000"
//axios.defaults.baseURL = "https://newbackend.greengecko.co.nz:5000"
//axios.defaults.baseURL = "https://newbackend.greengecko.co.nz"
axios.defaults.baseURL = "https://backend.instituteofspeed.com"

function App() {
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [user, setUser] = useState(null);
  const [loginData, setLoginData] = useState({ email: '', password: '' });
  const [error, setError] = useState('');

  const logout = () => {
    localStorage.removeItem('token');
    setToken(null);
    setUser(null);
  };

  useEffect(() => {
    if (token) {
      fetchUser();
    }
  }, [token]);

  const fetchUser = async () => {
    try {
      const response = await axios.get(`/users/me`, {
        headers: { Authorization: `Bearer ${token}` }
      , withCredentials: true 
      });
      setUser(response.data);
      setError('');
    } catch (err) {
      setError('Failed to fetch user data');
      logout();
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      formData.append('username', loginData.email);
      formData.append('password', loginData.password);

      const response = await axios.post(`/token`, formData, { withCredentials: true } );
      const { access_token } = response.data;
      console.log ( response.data );
      localStorage.setItem('token', access_token);
      setToken(access_token);
      setError('');
    } catch (err) {
      setError(err.response?.data?.detail || 'Login failed');
    }
  };

  if (user) {
    return (
      <div className="App">
        <div className="admin-container">
	  <Work />
	</div>
        <button onClick={logout} className="btn btn-right">
          Logout
        </button>
      </div>
    );
  }

  return (
    <div className="App">
      <div className="container">
        <h1>Profile Admin</h1>
        
        {error && <div className="error">{error}</div>}
        
          <form onSubmit={handleLogin}>
            <input
              type="email"
              placeholder="Email"
              value={loginData.email}
              onChange={(e) => setLoginData({ 
                ...loginData, 
                email: e.target.value 
              })}
              required
            />
            <input
              type="password"
              placeholder="Password"
              value={loginData.password}
              onChange={(e) => setLoginData({ 
                ...loginData, 
                password: e.target.value 
              })}
              required
            />
            <button type="submit" className="btn btn-primary">
              Login
            </button>
          </form>
      </div>
    </div>
  );
}

export default App;
